var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"default",on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default"):[_vm._v("\n      Loading ...\n    ")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }